import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { View } from '../layout/model/interfaces/view.interface';
import { SystemService } from '../shared/service/system/system.service';
import { filter, firstValueFrom, take } from 'rxjs';
import { AuthService } from '../auth/service/auth.service';
import { RouteGuardService } from './service/route-guard.service';

@Injectable({ providedIn: 'root' })
export class UsersViewGuard implements CanActivate {
  private routeGuardService = inject(RouteGuardService);

  private systemService = inject(SystemService);
  private authService = inject(AuthService);

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    await firstValueFrom(
      this.systemService.isInitialized$.pipe(
        filter((val) => val),
        take(1),
      ),
    );

    const routeUrl = this.routeGuardService.getRouteUrl(route);
    const hasPermission = this.authService.getRoutePermissions(routeUrl);
    if (!hasPermission) {
      return false;
    }

    await this.routeGuardService.handleRoute(this.getView(routeUrl), route);
    return true;
  }

  private getView(routeUrl: string): View {
    return {
      route: routeUrl,
      iframeUrl: 'users',
    };
  }
}
